import { call, takeLatest} from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

function* actionLogAdd(action) {
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('action', payload.action);
    params.append('value', payload.value);
    return axios.post(config.apiUri + "member/actionLogApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {

  }
  if (err) {
    console.log('err');
  }
}


const saga = [
  takeLatest('ACTION_LOG_ADD', actionLogAdd),
];

export default saga;
